import { Pipe, PipeTransform } from '@angular/core';
import { IPatient } from '@stockcare-models/IPatient';

@Pipe({
  standalone: false,
  name: 'filterPatient',
})
export class FilterPatientPipe implements PipeTransform {
  transform(items: IPatient[], filterBy: string): any {
      if(items === undefined) return;
    if (filterBy === '' || filterBy === undefined) return items;
    return items.filter(
      (item) => item.caseNumber.toLowerCase().includes(filterBy.toLowerCase()) || item.name.toLowerCase().includes(filterBy.toLowerCase())
    );
  }
}
